<template>
  <v-btn
    color="theme"
    class="my-2 my-sm-0 white--text"
    @click.prevent="onClick"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      class="mr-1"
    >
      <use xlink:href="#icon-book" />
    </svg>
    Estude agora
  </v-btn>
</template>
<script>
import { mapGetters } from "vuex";
import { selectModulesRouteName, studyNowRouteName } from '../constants/routes';

export default {
  computed: {
    ...mapGetters(['selectedCycle']),
    redirectRouteName(){
      return this.selectedCycle.should_select_modules ? selectModulesRouteName: studyNowRouteName ;
    }
  },
  methods: {
    onClick() {
      if( this.$route.name !== this.redirectRouteName ) {
        this.$router.push({name: this.redirectRouteName})
      }
    }
  },
}
</script>

